'use client'

import { addReactError } from '@datadog/browser-rum-react'
import { SomethingWentWrong } from '@/app/_shared/components/SomethingWentWrong'
import { ROUTES } from '@/app/routes'
import { useEffect } from 'react'

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
	useEffect(() => {
		console.error(error)
		if (process.env.NODE_ENV === 'development') return
		addReactError(error, { componentStack: 'Missing Stack' })
	}, [error])

	return <SomethingWentWrong goBackHref={ROUTES.home} reset={reset} />
}
